

export enum Color {
  SUCCESS = '--l-success',
  WARN = '--l-warn',
  DANGER = '--l-danger',
  INFO = '--l-info',
  UNKNOWN = '--l-unknown'
};
